export default "__VITE_ASSET__05fb478e__"